import type { ReplaceKind } from '@avs/contract';
import type { IconName } from '../icons/registry.js';

export const KIND_LABEL: Record<ReplaceKind, string> = {
  object: '物体替换',
  scene: '场景替换',
  person: '人物替换',
};

export const KIND_ICON: Record<ReplaceKind, IconName> = {
  object: 'object',
  scene: 'image',
  person: 'user',
};

export const KIND_DESC: Record<ReplaceKind, string> = {
  object: '面向商品、主体、道具替换的批量生产流程，支持 Prompt 与策略调参。',
  scene: '保持主体一致，将视频背景或场景批量改造，支持 Prompt 与策略调参。',
  person: '面向真人形象、服饰和身份特征的批量替换，支持 Prompt 与策略调参。',
};

export const KIND_REF_LABEL: Record<ReplaceKind, string> = {
  object: '物体参考图',
  scene: '场景参考图',
  person: '人物参考图',
};

export const KIND_PROMPT_PLACEHOLDER: Record<ReplaceKind, string> = {
  object: '请将原视频中的目标物体替换为参考图中的物体，保持运动节奏与遮挡关系。',
  scene: '请将原视频背景替换为参考图所示场景，保持主体不变。',
  person: '请将原视频中的目标人物替换为参考人物形象，保留原动作与表情。',
};

export const STRATEGIES: Record<ReplaceKind, ReadonlyArray<string>> = {
  object: ['完全替换', '保持轮廓', '保持材质', '智能融合'],
  scene: ['整体替换', '仅替换天空', '保留前景主体', '风格迁移'],
  person: ['完全替换', '仅替换服饰', '仅替换面部', '保留动作姿态'],
};

export const SEARCH_PLACEHOLDER: Record<ReplaceKind, string> = {
  object: '搜索物体替换任务 / Batch ID',
  scene: '搜索场景替换任务 / Batch ID',
  person: '搜索人物替换任务 / Batch ID',
};
